// import { useContext, useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import '../assets/styles/pages.scss';
// import DashboardCard from '../components/dashboard-card';
// import Graph from '../components/graph';
// import { GlobalContext, handleError } from '../context/Provider';
// import henceforthApi from '../utils/henceforthApi';
// import { numberWithCommas } from '../utils/validations';
// const Sales = 'sales'
// const Product = 'product'
// interface counts {
//   total_products: string,
//   total_orders: string,
//   alert_of_stock: string,
//   out_of_stock: string,
//   total_earnings: string,
//   total_ratings: string,
//   total_reviews: string,
// }

// const Home = () => {
//   const { authState, loading, setLoading, language_data, authDispatch } = useContext(GlobalContext);
//   const location = useLocation()
//   const navigate = useNavigate()
//   let newParam = new URLSearchParams(location.search)
//   let ProductMatch = newParam.get(Product) as string | null
//   let SalesMatch = newParam.get(Sales) as string | null

//   const [count, setCount] = useState({
//     total_products: "",
//     total_orders: "",
//     alert_of_stock: "",
//     out_of_stock: "",
//     total_earnings: "",
//     total_ratings: "",
//     total_reviews: "",
//   } as counts)
//   const [loadingG, setLoadingG] = useState({
//     product: false,
//     sales: false
//   })
//   const [productX, setProductX] = useState<string>('')
//   const [salesX, setSalesX] = useState<string>('')
//   const [productGraph, setProductGraph] = useState([] as any)
//   const [salesGraph, setSalesGraph] = useState([] as any)
//   const dashboardDetails = async () => {
//     setLoading(true)
//     try {
//       let res = (await henceforthApi.Dashboard.getTotalOrderCount()).data;
//       setCount(res)
//     } catch (error: any) {
//       handleError(error, '', authDispatch);
//     } finally {
//       setLoading(false)
//     }
//   }
//   const dashboadGraph = async (graph: string, type: string) => {
//     if (graph && type) {
//       newParam.set(graph, type)
//     }
//     let types = type === "DAILY" ? 'hour' : type === "WEEKLY" ? 'day' : type === "MONTHLY" ? 'date' : type === "YEARLY" ? 'month' : ''
//     if (graph === Product) setProductX(types)
//     if (graph === Sales) setSalesX(types)
//     setLoadingG({
//       ...loadingG,
//       [graph]: true
//     })
//     try {
//       let res = (await henceforthApi.Dashboard.getGraph(graph, type)).data.data;
//       if (graph === 'product') {
//         setProductGraph(res)
//       } else {
//         setSalesGraph(res)
//       }
//       navigate({ search: newParam.toString() })
//     } catch (error: any) {
//       handleError(error, '', authDispatch);


//     } finally {
//       setLoadingG({
//         ...loadingG,
//         [graph]: false
//       })
//     }
//   }
//   useEffect(() => {
//     dashboardDetails()
//   }, [])
//   useEffect(() => {
//     dashboadGraph('product', 'DAILY')
//     dashboadGraph('sales', 'DAILY')
//   }, [])
//   const dashboardCardArray = [
//     { url: '/products/1', title: language_data?.[authState.lang]?.common_product, description: `${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_count}`, count: count.total_products ? count.total_products : '0', icon: "fa-laptop" },
//     { url: '/orders/1', title: language_data?.[authState.lang]?.common_order, description: `${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_order} ${language_data?.[authState.lang]?.common_count}`, count: count.total_orders ? count.total_orders : '0', icon: 'fa-shopping-cart' },
//     { url: `/products/1?out_of_stock=true`, title: language_data?.[authState.lang]?.common_out_of_stock, description: `${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.home_that_are} ${language_data?.[authState.lang]?.common_out_of_stock}`, count: count.out_of_stock ? count.out_of_stock : '0', icon: "fa-home" },
//     { url: '/products/1?qty=5', title: language_data?.[authState.lang]?.common_alert_of_stock, description: `${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.home_that_will_soon_go_out_of_that_ie_quantity_less_then} ${language_data?.[authState.lang]?._5} `, count: count.alert_of_stock ? count.alert_of_stock : '0', icon: 'fa-bell' },
//     { url: '/ratings/1?order_status=DELIVERED', title: language_data?.[authState.lang]?.common_rating_reviews, description: `${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_rating} ${language_data?.[authState.lang]?.common_count}`, count: count.total_ratings || count.total_reviews ? `${count.total_ratings} & ${count.total_reviews}` : "0", icon: 'fa-star' },
//     { url: '/earnings/1', title: language_data?.[authState.lang]?.common_earning, description: `${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_earning} ${language_data?.[authState.lang]?.home_addition_of_all_order_pricing}`, count: count.total_earnings ? numberWithCommas(Number(count.total_earnings)) : "0", icon: 'fa-dollar' }
//   ]

//   return (
//     <div className='page-spacing'>
//       {/****************** Dashboard-Graph  *******************/}
//       <section className='dashboard-graph'>
//         <div className="container-fluid">
//           <div className="row">
//             {/* Product Graph  */}
//             {authState?.role !== 'store' && <Graph heading={language_data?.[authState.lang]?.common_product_graph} Match={ProductMatch} run={Product} data={productGraph} xAxis={productX} yAxis={language_data?.[authState.lang]?.home_total_product} dashboadGraph={dashboadGraph} loading={loadingG.product} />}
//             {/* Sales Graph  */}
//             <Graph heading={language_data?.[authState.lang]?.common_sales_graph} Match={SalesMatch} run={Sales} data={salesGraph} xAxis={salesX} yAxis={language_data?.[authState.lang]?.home_total_orders} dashboadGraph={dashboadGraph} loading={loadingG.sales} />
//           </div>
//         </div>
//       </section>
//       {/****************** Dashboard-Stats  *******************/}
//       <section className='dashboard-stats'>
//         <div className="container-fluid">
//           <div className="row gy-4">
//             {dashboardCardArray.map((res, index: number) => <div className="col-md-6 col-lg-6 col-xl-4 col-xxl-4 custom-dashboard-card px-0 px-md-2" key={index}>
//               <DashboardCard url={res.url} title={res.title} loading={loading} description={res.description} count={res.count} icon={res.icon} />
//             </div>)}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;
// import { useContext, useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import '../assets/styles/pages.scss';
// import DashboardCard from '../components/dashboard-card';
// import Graph from '../components/graph';
// import { GlobalContext, handleError } from '../context/Provider';
// import henceforthApi from '../utils/henceforthApi';
// import { numberWithCommas } from '../utils/validations';

// const Sales = 'sales';
// const Product = 'product';

// interface counts {
//   total_products: string;
//   total_stores: string;
//   total_orders: string;
//   alert_of_stock: string;
//   out_of_stock: string;
//   total_earnings: string;
//   total_ratings: string;
//   total_reviews: string;
// }

// const FILTER_TYPES = ['DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY'];

// const Home = () => {
//   const { authState, loading, setLoading, language_data, authDispatch } = useContext(GlobalContext);
//   const location = useLocation();
//   const navigate = useNavigate();
//   let newParam = new URLSearchParams(location.search);
//   let ProductMatch = newParam.get(Product) as string | null;
//   let SalesMatch = newParam.get(Sales) as string | null;

//   const [count, setCount] = useState({
//     total_products: "",
//     total_stores: "",
//     total_orders: "",
//     alert_of_stock: "",
//     out_of_stock: "",
//     total_earnings: "",
//     total_ratings: "",
//     total_reviews: "",
//   } as counts);

//   const [groupFilterType, setGroupFilterType] = useState<string>('MONTHLY');

//   const [loadingG, setLoadingG] = useState({
//     product: false,
//     sales: false
//   });
//   const [productX, setProductX] = useState<string>('');
//   const [salesX, setSalesX] = useState<string>('');
//   const [productGraph, setProductGraph] = useState([] as any);
//   const [salesGraph, setSalesGraph] = useState([] as any);

//   const fetchDashboardData = async (filterType: string) => {
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       params.append('filter_type', filterType);
//       let res = (await henceforthApi.Dashboard.getTotalOrderCount(params.toString())).data;
//       setCount((prev) => ({ ...prev, ...res }));
//     } catch (error: any) {
//       handleError(error, '', authDispatch);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const dashboadGraph = async (graph: string, type: string) => {
//     if (graph && type) {
//       newParam.set(graph, type);
//     }
//     let types = type === "DAILY" ? 'hour' : type === "WEEKLY" ? 'day' : type === "MONTHLY" ? 'date' : type === "YEARLY" ? 'month' : '';
//     if (graph === Product) setProductX(types);
//     if (graph === Sales) setSalesX(types);
//     setLoadingG({
//       ...loadingG,
//       [graph]: true
//     });
//     try {
//       let res = (await henceforthApi.Dashboard.getGraph(graph, type)).data.data;
//       if (graph === 'product') {
//         setProductGraph(res);
//       } else {
//         setSalesGraph(res);
//       }
//       navigate({ search: newParam.toString() });
//     } catch (error: any) {
//       handleError(error, '', authDispatch);
//     } finally {
//       setLoadingG({
//         ...loadingG,
//         [graph]: false
//       });
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData(groupFilterType);
//   }, [groupFilterType]);

//   useEffect(() => {
//     dashboadGraph('product', 'DAILY');
//     dashboadGraph('sales', 'DAILY');
//   }, []);

//   const getCardPeriodText = () => {
//     const map: any = {
//       DAILY: language_data?.[authState.lang]?.common_daily || 'Daily',
//       WEEKLY: language_data?.[authState.lang]?.common_weekly || 'Weekly',
//       MONTHLY: language_data?.[authState.lang]?.common_monthly || 'Monthly',
//       YEARLY: language_data?.[authState.lang]?.common_yearly || 'Yearly',
//     };
//     return map[groupFilterType] || groupFilterType;
//   };

//   return (
//     <div className='page-spacing'>
//       {/****************** Dashboard-Graph  *******************/}
//       <section className='dashboard-graph'>
//         <div className="container-fluid">
//           <div className="row">
//             {authState?.role !== 'store' && <Graph heading={language_data?.[authState.lang]?.common_product_graph} Match={ProductMatch} run={Product} data={productGraph} xAxis={productX} yAxis={language_data?.[authState.lang]?.home_total_product} dashboadGraph={dashboadGraph} loading={loadingG.product} />}
//             <Graph heading={language_data?.[authState.lang]?.common_sales_graph} Match={SalesMatch} run={Sales} data={salesGraph} xAxis={salesX} yAxis={language_data?.[authState.lang]?.home_total_orders} dashboadGraph={dashboadGraph} loading={loadingG.sales} />
//           </div>
//         </div>
//       </section>
//       {/****************** Overall Statistics Parent Card (4 cards) *******************/}
//       <section className='dashboard-stats-parent mt-2'>
//         <div className="container-fluid">
//           <div className="common-card border rounded shadow-sm">
//             <div className="common-card-title d-flex justify-content-between align-items-center p-3 border-bottom bg-light">
//               <h5 className="m-0 fw-bold text-dark">Overall Statistics</h5>
//               {/* Inline Pill Filter buttons */}
//               <div className="d-flex align-items-center gap-2">
//                 <span className="fw-semibold text-secondary d-none d-sm-inline" style={{ fontSize: '13px' }}>Filter Type:</span>
//                 <div className="d-flex align-items-center gap-1 bg-white p-1 border rounded-pill shadow-sm">
//                   {FILTER_TYPES.map((type) => {
//                     const isActive = groupFilterType === type;
//                     return (
//                       <button
//                         key={type}
//                         type="button"
//                         className={`btn btn-xs px-3 py-1 rounded-pill fw-bold border-0 text-nowrap`}
//                         style={{
//                           fontSize: '11px',
//                           backgroundColor: isActive ? '#5c46e4' : 'transparent',
//                           color: isActive ? '#fff' : '#495057',
//                           transition: 'all 0.2s ease',
//                           cursor: 'pointer'
//                         }}
//                         onClick={() => setGroupFilterType(type)}
//                       >
//                         {type.charAt(0) + type.slice(1).toLowerCase()}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>

//             <div className="common-card-content p-3">
//               <div className="row gy-3">
//                 {/* 1. Products Card */}
//                 <div className="col-md-6 col-lg-3 custom-dashboard-card px-2">
//                   <DashboardCard
//                     url="/products/1"
//                     title={language_data?.[authState.lang]?.common_product}
//                     description={`${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.common_count}`}
//                     count={count.total_products ? count.total_products : '0'}
//                     icon="fa-laptop"
//                     loading={loading}
//                     periodText={getCardPeriodText()}
//                   />
//                 </div>

//                 {/* 2. Total Stores Card */}
//                 {authState?.role !== 'store' && (
//                   <div className="col-md-6 col-lg-3 custom-dashboard-card px-2">
//                     <DashboardCard
//                       url="/store"
//                       title={language_data?.[authState.lang]?.common_stores || 'Total Stores'}
//                       description={`${language_data?.[authState.lang]?.common_total} Stores Count`}
//                       count={count.total_stores ? count.total_stores : '0'}
//                       icon="fa-home"
//                       loading={loading}
//                       periodText={getCardPeriodText()}
//                     />
//                   </div>
//                 )}

//                 {/* 3. Orders Card */}
//                 <div className="col-md-6 col-lg-3 custom-dashboard-card px-2">
//                   <DashboardCard
//                     url="/orders/1"
//                     title={language_data?.[authState.lang]?.common_order}
//                     description={`${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_order} ${language_data?.[authState.lang]?.common_count}`}
//                     count={count.total_orders ? count.total_orders : '0'}
//                     icon="fa-shopping-cart"
//                     loading={loading}
//                     periodText={getCardPeriodText()}
//                   />
//                 </div>

//                 {/* 4. Earnings Card */}
//                 <div className="col-md-6 col-lg-3 custom-dashboard-card px-2">
//                   <DashboardCard
//                     url="/earnings/1"
//                     title={language_data?.[authState.lang]?.common_earning}
//                     description={`${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_earning} ${language_data?.[authState.lang]?.home_addition_of_all_order_pricing}`}
//                     count={count.total_earnings ? numberWithCommas(Number(count.total_earnings)) : "0"}
//                     icon="fa-dollar"
//                     loading={loading}
//                     periodText={getCardPeriodText()}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/****************** Stock Alerts Parent Card (2 cards) *******************/}
//       <section className='dashboard-stats-parent mt-3'>
//         <div className="container-fluid">
//           <div className="common-card border rounded shadow-sm mb-4">
//             <div className="common-card-title p-3 border-bottom bg-light">
//               <h5 className="m-0 fw-bold text-dark">Stock Alerts</h5>
//             </div>
//             <div className="common-card-content p-3">
//               <div className="row gy-3">
//                 <div className="col-md-6 custom-dashboard-card px-2">
//                   <DashboardCard
//                     url={`/products/1?out_of_stock=true`}
//                     title={language_data?.[authState.lang]?.common_out_of_stock}
//                     description={`${language_data?.[authState.lang]?.common_total} ${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.home_that_are} ${language_data?.[authState.lang]?.common_out_of_stock}`}
//                     count={count.out_of_stock ? count.out_of_stock : '0'}
//                     icon="fa-home"
//                     loading={loading}
//                     periodText="Total"
//                   />
//                 </div>
//                 <div className="col-md-6 custom-dashboard-card px-2">
//                   <DashboardCard
//                     url="/products/1?qty=5"
//                     title={language_data?.[authState.lang]?.common_alert_of_stock}
//                     description={`${language_data?.[authState.lang]?.common_product} ${language_data?.[authState.lang]?.home_that_will_soon_go_out_of_that_ie_quantity_less_then} ${language_data?.[authState.lang]?._5}`}
//                     count={count.alert_of_stock ? count.alert_of_stock : '0'}
//                     icon="fa-bell"
//                     loading={loading}
//                     periodText="Total"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// };

// export default Home;

// Home.tsx
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../assets/styles/pages.scss';
import DashboardCard from '../components/dashboard-card';
import Graph from '../components/graph';
import { GlobalContext, handleError } from '../context/Provider';
import henceforthApi from '../utils/henceforthApi';
import { numberWithCommas } from '../utils/validations';
import commonArray from '../components/common/commonArray';

const Sales = 'sales';
const Product = 'product';

interface counts {
  total_products: string;
  total_stores: string;
  total_orders: string;
  alert_of_stock: string;
  out_of_stock: string;
  total_earnings: string;
  total_ratings: string;
  total_reviews: string;
  total_items: string;
  total_quantity?: string;
}

const Home = () => {
  const {
    authState, loading, setLoading,
    language_data, authDispatch
  } = useContext(GlobalContext);

  const location = useLocation();
  const navigate = useNavigate();
  let newParam = new URLSearchParams(location.search);
  let ProductMatch = newParam.get(Product) as string | null;
  let SalesMatch = newParam.get(Sales) as string | null;

  const [count, setCount] = useState<counts>({
    total_products: "",
    total_stores: "",
    total_orders: "",
    alert_of_stock: "",
    out_of_stock: "",
    total_earnings: "",
    total_ratings: "",
    total_reviews: "",
    total_items: "",
  });

  // ✅ Default matches graph default
  const [groupFilterType, setGroupFilterType] = useState<string>('DAILY');

  const [loadingG, setLoadingG] = useState({ product: false, sales: false });
  const [productX, setProductX] = useState<string>('');
  const [salesX, setSalesX] = useState<string>('');
  const [productGraph, setProductGraph] = useState<any[]>([]);
  const [salesGraph, setSalesGraph] = useState<any[]>([]);

  // ============================================================
  // FETCH COUNTS
  // ============================================================
  const fetchDashboardData = async (filterType: string) => {
    setLoading(true);
    try {
      const res = (
        await henceforthApi.Dashboard.getTotalOrderCount(
          `filter_type=${filterType}`
        )
      ).data;
      console.log("ress", res);

      const dashboardData = res || {};

      setCount((prev) => ({
        ...prev,
        ...dashboardData,
      }));
    } catch (error: any) {
      handleError(error, '', authDispatch);
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // GRAPH
  // ============================================================
  const dashboadGraph = async (graph: string, type: string) => {
    if (graph && type) newParam.set(graph, type);

    const types =
      type === "DAILY" ? 'hour' :
        type === "WEEKLY" ? 'day' :
          type === "MONTHLY" ? 'date' :
            type === "YEARLY" ? 'month' : '';

    if (graph === Product) setProductX(types);
    if (graph === Sales) setSalesX(types);

    setLoadingG((prev) => ({ ...prev, [graph]: true }));
    try {
      const res = (
        await henceforthApi.Dashboard.getGraph(graph, type)
      ).data.data;
      if (graph === 'product') setProductGraph(res);
      else setSalesGraph(res);
      navigate({ search: newParam.toString() });
    } catch (error: any) {
      handleError(error, '', authDispatch);
    } finally {
      setLoadingG((prev) => ({ ...prev, [graph]: false }));
    }
  };

  // ============================================================
  // EFFECTS
  // ============================================================
  useEffect(() => {
    fetchDashboardData(groupFilterType);
  }, [groupFilterType]);

  useEffect(() => {
    dashboadGraph('product', 'DAILY');
    dashboadGraph('sales', 'DAILY');
  }, []);

  // ============================================================
  // HELPERS
  // ============================================================
  const getCardPeriodText = () => {
    const map: Record<string, string> = {
      DAILY: language_data?.[authState.lang]?.common_daily || 'Daily',
      WEEKLY: language_data?.[authState.lang]?.common_weekly || 'Weekly',
      MONTHLY: language_data?.[authState.lang]?.common_monthly || 'Monthly',
      YEARLY: language_data?.[authState.lang]?.common_yearly || 'Yearly',
    };
    return map[groupFilterType] || groupFilterType;
  };

  // ============================================================
  // RENDER
  // ============================================================
  return (
    <div className='page-spacing'>

      {/****************** Graphs *******************/}
      <section className='dashboard-graph'>
        <div className="container-fluid">
          <div className="row">
            {authState?.role !== 'store' && (
              <Graph
                heading={language_data?.[authState.lang]?.common_product_graph}
                Match={ProductMatch}
                run={Product}
                data={productGraph}
                xAxis={productX}
                yAxis={language_data?.[authState.lang]?.home_total_product}
                dashboadGraph={dashboadGraph}
                loading={loadingG.product}
              />
            )}
            <Graph
              heading={language_data?.[authState.lang]?.common_sales_graph}
              Match={SalesMatch}
              run={Sales}
              data={salesGraph}
              xAxis={salesX}
              yAxis={language_data?.[authState.lang]?.home_total_orders}
              dashboadGraph={dashboadGraph}
              loading={loadingG.sales}
            />
          </div>
        </div>
      </section>

      {/****************** Overall Statistics — Parent Card *******************/}
      <section className='dashboard-stats-parent mt-2'>
        <div className="container-fluid">
          <div className="common-card">

            {/* ✅ Header: Title LEFT | Filter buttons RIGHT — exact same style as Graph */}
            <div className="common-card-title d-flex justify-content-between align-items-center flex-column flex-md-row">
              <h5 className="text-nowrap mb-2 mb-md-0">
                Overall Statistics
              </h5>
              {/* ✅ Same btn-group + btn-white + active-btn as Graph component */}
              <div className="btn-group">
                {commonArray.buttonArray.map((res: string, index: number) => (
                  <button
                    key={index}
                    type="button"
                    className={`btn btn-white ${groupFilterType === res.toUpperCase()
                      ? 'active-btn'
                      : ''
                      }`}
                    onClick={() => setGroupFilterType(res.toUpperCase())}
                    disabled={loading}
                  >
                    {res}
                  </button>
                ))}
              </div>
            </div>

            {/* ✅ 4 Cards — 2 per row (col-md-6) */}
            <div className="common-card-content">
              <div className="row gy-3">

                {/* 1. Products */}
                <div className="col-sm-6 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/products/1"
                    title={
                      language_data?.[authState.lang]?.common_product
                      || 'Products'
                    }
                    description={`${language_data?.[authState.lang]?.common_total || 'Total'} ${language_data?.[authState.lang]?.common_product || 'Product'} ${language_data?.[authState.lang]?.common_count || 'Count'}`}
                    count={count.total_products || '0'}
                    icon="fa-laptop"
                    loading={loading}
                    periodText={getCardPeriodText()}
                  />
                </div>

                {authState?.role !== 'store' && (
                  <div className="col-sm-6 custom-dashboard-card px-2">
                    <DashboardCard
                      url="/store"
                      title={
                        language_data?.[authState.lang]?.common_stores
                        || 'Total Stores'
                      }
                      description={`${language_data?.[authState.lang]?.common_total || 'Total'} Stores Count`}
                      count={count.total_stores || '0'}
                      icon="fa-home"
                      loading={loading}
                      periodText={getCardPeriodText()}
                    />
                  </div>
                )}

                {/* 3. Orders */}
                <div className="col-sm-6 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/orders/1"
                    title={
                      language_data?.[authState.lang]?.common_order
                      || 'Orders'
                    }
                    description={`${language_data?.[authState.lang]?.common_total || 'Total'} ${language_data?.[authState.lang]?.common_order || 'Order'} ${language_data?.[authState.lang]?.common_count || 'Count'}`}
                    count={count.total_orders || '0'}
                    icon="fa-shopping-cart"
                    loading={loading}
                    periodText={getCardPeriodText()}
                  />
                </div>

                {authState?.role !== 'store' && (
                  <div className="col-sm-6 custom-dashboard-card px-2">
                    <DashboardCard
                      url="/products/1"
                      title={
                        language_data?.[authState.lang]?.common_items
                        || 'Total Items'
                      }
                      description={`${language_data?.[authState.lang]?.common_total || 'Total'} Items Count`}
                      count={count.total_items || '0'}
                      icon="fa-home"
                      loading={loading}
                      periodText={getCardPeriodText()}
                    />
                  </div>
                )}

                {/* 4. Earnings */}
                <div className="col-sm-6 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/earnings/1"
                    title={
                      language_data?.[authState.lang]?.common_earning
                      || 'Earnings'
                    }
                    description={`${language_data?.[authState.lang]?.common_total || 'Total'} ${language_data?.[authState.lang]?.common_earning || 'Earning'} ${language_data?.[authState.lang]?.home_addition_of_all_order_pricing || ''}`}
                    count={
                      count.total_earnings
                        ? numberWithCommas(Number(count.total_earnings))
                        : "0"
                    }
                    icon="fa-dollar"
                    loading={loading}
                    periodText={getCardPeriodText()}
                  />
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/****************** Stock Alerts — Separate Parent Card *******************/}
      <section className="dashboard-stats-parent mt-2">
        <div className="container-fluid">
          <div className="common-card">

            <div className="common-card-title d-flex justify-content-between align-items-center">
              <h5 className="text-nowrap m-0">
                Store Quantities & Stock Alerts
              </h5>
            </div>

            <div className="common-card-content">
              <div className="row gy-3">

                {/* Out of Stock */}
                <div className="col-12 col-md-6 col-lg-4 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/products/1?out_of_stock=true"
                    title={
                      language_data?.[authState.lang]?.common_out_of_stock ||
                      "Out of Stock"
                    }
                    description={`${language_data?.[authState.lang]?.common_total || "Total"} ${language_data?.[authState.lang]?.common_product || "Product"
                      } ${language_data?.[authState.lang]?.home_that_are || "that are"
                      } ${language_data?.[authState.lang]?.common_out_of_stock ||
                      "Out of Stock"
                      }`}
                    count={count.out_of_stock || "0"}
                    icon="fa-exclamation-circle"
                    loading={loading}
                    periodText="All Time"
                  />
                </div>

                {/* Alert of Stock */}
                <div className="col-12 col-md-6 col-lg-4 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/products/1?qty=5"
                    title={
                      language_data?.[authState.lang]?.common_alert_of_stock ||
                      "Alert of Stock"
                    }
                    description={`${language_data?.[authState.lang]?.common_product || "Product"} ${language_data?.[authState.lang]
                        ?.home_that_will_soon_go_out_of_that_ie_quantity_less_then ||
                      "quantity less than"
                      } ${language_data?.[authState.lang]?._5 || "5"
                      }`}
                    count={count.alert_of_stock || "0"}
                    icon="fa-bell"
                    loading={loading}
                    periodText="All Time"
                  />
                </div>

                {/* Total Quantity */}
                <div className="col-12 col-md-6 col-lg-4 custom-dashboard-card px-2">
                  <DashboardCard
                    url="/products/1"
                    title={
                      language_data?.[authState.lang]?.common_total_quantity ||
                      "Total Quantity"
                    }
                    description={
                      language_data?.[authState.lang]
                        ?.common_total_quantity_description ||
                      "Total available quantity across all products"
                    }
                    count={count.total_quantity || "0"}
                    icon="fa-boxes"
                    loading={loading}
                    periodText="All Time"
                  />
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;